"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSwipeableCarousel = void 0;
var _react = require("react");
const SWIPE_THRESHOLD = 50;
const useSwipeableCarousel = function () {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);
  const touchStartX = (0, _react.useRef)(0);
  const touchEndX = (0, _react.useRef)(0);
  const onTouchStart = (0, _react.useCallback)(e => {
    touchStartX.current = e.touches[0].clientX;
  }, []);
  const onTouchMove = (0, _react.useCallback)(e => {
    touchEndX.current = e.touches[0].clientX;
  }, []);
  const onTouchEnd = (0, _react.useCallback)(() => {
    const diff = touchStartX.current - touchEndX.current;
    if (diff > SWIPE_THRESHOLD && activeIndex < length - 1) {
      setActiveIndex(prev => prev + 1);
    }
    if (diff < -SWIPE_THRESHOLD && activeIndex > 0) {
      setActiveIndex(prev => prev - 1);
    }
  }, [activeIndex, length]);
  return {
    activeIndex,
    setActiveIndex,
    swipeHandlers: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  };
};
exports.useSwipeableCarousel = useSwipeableCarousel;